import { fetchSessionToken } from './sessionToken';
import createApp from '@shopify/app-bridge';

const params = new URLSearchParams(window.location.search);
const shop = params.get('shop');
const host = params.get('host');
const config = {
  apiKey: 'e01adf90e60dcfdb4e39b5485859d18b', // Use env var in prod!
  shopOrigin: shop,
  host,
  forceRedirect: true,
};
const app = createApp(config);

export async function authenticatedFetch(url, options = {}) {
  const token = await fetchSessionToken(app);
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
